module.exports = __webpack_public_path__ + "static/assets/4e804e27c7be58fedf42160c8a180174.svg";